import { render } from "./EsgTab.vue?vue&type=template&id=b41ef8ce"
import script from "./EsgTab.vue?vue&type=script&lang=js"
export * from "./EsgTab.vue?vue&type=script&lang=js"

import "./EsgTab.vue?vue&type=style&index=0&id=b41ef8ce&lang=scss"

import exportComponent from "/Users/tony/argon2/vue-argon-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__